import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "MailLocalSearch" */ "./lazyIndex"), { name: "MailLocalSearch" });

export const lazyLoadMoreGqlSearch: LazyAction<typeof lazyIndex.loadMoreGqlSearch, typeof lazyModule> = new LazyAction(lazyModule, m => m.loadMoreGqlSearch);
export const lazyLoadLocalMailSearchTable: LazyAction<typeof lazyIndex.loadLocalMailSearchTable, typeof lazyModule> = new LazyAction(lazyModule, m => m.loadLocalMailSearchTable);
